// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"1014418d","208":"0e493b61","236":"fca70bd9","353":"e17b8ed9","512":"68a810df","549":"8b242a51","813":"75b03d1e"}[chunkId] + ".chunk.js";
};